export default __webpack_public_path__ + "static/media/step 3.bb5af52d.PNG";